import { Flex, Space } from "antd";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { AppButton, AppForm, AppText, AppTitle } from "@/shared/Components";
import { FormInputPassword } from "@/shared/Components/Form/FormInputs/FormInputPassword";
import type { EnterPinFormValues } from "../model/types";
import { getPinCodeSchema } from "../model/schema";
import styles from "./styles.module.scss";

type Props = {
  onSubmit: (pin: string) => void;
  hasError?: boolean;
};

export const EnterPinForm = ({ onSubmit, hasError }: Props) => {
  const { t } = useTranslation();
  const formApi = useForm({
    resolver: yupResolver(getPinCodeSchema()),
  });

  const handleSubmit = (values: EnterPinFormValues) => {
    onSubmit(values.pin);
  };

  useEffect(() => {
    if (hasError) {
      formApi.reset();
      formApi.setError("pin", { message: t("enterPinPage.incorrectPin") });
    }
  }, [hasError]);

  return (
    <div>
      <AppForm formApi={formApi} onSubmit={handleSubmit}>
        <Flex className={styles.wrapper} vertical gap={16}>
          <AppTitle level={3} className={styles.title}>
            {t("enterPinPage.title")}
          </AppTitle>
          <AppText className={styles.subtitle}>{t("enterPinPage.subtitle")}</AppText>
          <Space direction="vertical" className={styles.input}>
            <FormInputPassword
              name="pin"
              placeholder={t("registrationPage.createPinStep.pin")}
              className={styles["registration-input"]}
            />
            <AppButton
              htmlType="submit"
              type="primary"
              className={styles.submit}
              disabled={!formApi.watch("pin")}
            >
              {t("common.confirm")}
            </AppButton>
          </Space>
        </Flex>
      </AppForm>
    </div>
  );
};
